"use client";
import Head from "next/head";
import Slideshow from "../components/slideshow/slideshow.jsx";
import LifestylePop from "../components/lifestyle-pop/lifestyle-pop.jsx";
import FAQs from "../components/connect/connect.jsx";

export default function FLPConnect() {
  const slideData = [
    {
      title: "FLP connect",
      description: "Powered by UConnect",
      buttonLabel: "",
      buttonLink: "/link-to-page",
      imageUrl:
        "https://nouf-flp-images.s3.af-south-1.amazonaws.com/6843E_FLP+Reskin_Connect.jpg",
      mobileImageUrl:
        "https://nouf-flp-images.s3.af-south-1.amazonaws.com/newneq.jpg",
      textdec: "italic",
    },
  ];

  const options = {
    // Customize Flickity options here
    cellAlign: "left",
    contain: true,
    freeScroll: true,
    wrapAround: true,
    adaptiveHeight: true,

    autoPlay: 4000,
    prevNextButtons: false,
  };
  return (
    <div>
      <Head>
        <title>FLP Connect</title>
        <meta
          name="First Loyalty Plus"
          content="First Loyalty Plus"
        />
        <link rel="icon" href="/favicon.ico" />
      </Head>

      <Slideshow banners={slideData} options={options} textdec="underline" />
      <LifestylePop
        backgroundImage="https://nouf-flp-images.s3.af-south-1.amazonaws.com/goprem.jpg"
        title="Go Premium"
        subtext="<p>JOIN FLP CONNECT FOR R249pm<br><br>

            Get your monthly subscription back in airtime
            PLUS all the wonderful FLP Standard benefits.<br><br>
            
            For R249 p/m get R249 back in airtime<br>
            EVERY MONTH!</p>"
        popUpContent="<div>
            </div>"
        logo1={{ alt: "", src: "", visibility: false }}
        logo2={{ alt: "", src: "", visibility: false }}
        logo3={{ alt: "", src: "", visibility: false }}
        butcol="red"
        button1={{
          text: "Join FLP Connect",
          link: "/join-now",
          visibility: true,
          popup: false,
        }}
        button2={{ text: "", link: "", visibility: false, popup: false }}
        contentAlign="right"
        popUpImage="/images/Spa_PopUp.png"
      />
      <LifestylePop
        backgroundImage="https://nouf-flp-images.s3.af-south-1.amazonaws.com/6843E_FLP+Reskin_Connect-2.jpg"
        title="FLP Connect Includes:"
        subtext="<p><b>R249 back in airtime EVERY MONTH</b><br>
            Up to R120 OFF Dining at 2,000+ Restaurants<br>
            Save on Flights & Car Hire<br>
            Save on Tours & Activities<br>
            Up to 50% OFF Deals-4-U<br>
            20% OFF Spa Treatments<br>
            Up to 50% OFF Holidays<br>
            Up to 20% OFF Cruises<br>
            50% OFF Movies</p>"
        popUpContent=""
        logo1={{ alt: "", src: "", visibility: false }}
        logo2={{ alt: "", src: "", visibility: false }}
        logo3={{ alt: "", src: "", visibility: false }}
        button1={{ text: "", link: "", visibility: false, popup: false }}
        button2={{ text: "", link: "", visibility: false, popup: false }}
        contentAlign="left"
        popUpImage="/images/Spa_PopUp.png"
      />
      <FAQs />
    </div>
  );
}
